import { createFileRoute } from "@tanstack/react-router";

import { GroupLanding } from "../components/landing/group-landing";
import { GROUP_PAGES, groupPageJsonLd } from "../lib/group-pages";
import { seo } from "../lib/head";

const page = GROUP_PAGES.secret_santa;

export const Route = createFileRoute("/secret-santa")({
  staticData: { ssr: true },
  head: () =>
    seo({
      title: page.seoTitle,
      description: page.seoDescription,
      image: page.ogImage,
      jsonLd: groupPageJsonLd(page),
    }),
  component: () => <GroupLanding mode="secret_santa" />,
});
